var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageLine = function SvgMessageLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M2.5 7.746A4.49 4.49 0 0 1 7 3.25h6c2.485 0 4.5 2.021 4.5 4.496v9.004H7a4.504 4.504 0 0 1-4.5-4.495zM16 15.25V7.746a3.003 3.003 0 0 0-3-2.996H7a2.99 2.99 0 0 0-3 2.996v4.509a3.003 3.003 0 0 0 3 2.995zm-4.5-6H13v1.5h-1.5zm-4.5 0h1.5v1.5H7z"
  })));
};
export default SvgMessageLine;